import { Component } from '@angular/core';
import { PoBreadcrumb, PoDialogService, PoNotificationService } from '@po-ui/ng-components';
import { MedicosDominioService } from '../medicos-dominio.service';

@Component({
  selector: 'app-medicos-dominio',
  standalone: false,

  templateUrl: './medicos-dominio.component.html',
  styleUrl: './medicos-dominio.component.css'
})
export class MedicosDominioComponent {

  readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Contabilidade' }, { label: 'Médicos Domínio' }]
  };

  idEmpresa: number = 0;
  dataInicial: string = '';
  dataFinal: string = '';
  periodo: any = {};
  isLoading: boolean = false;

  constructor(private readonly medicosContabilService: MedicosDominioService,
    private readonly poDialogService: PoDialogService,
    private readonly poNotificationService: PoNotificationService) { }
  requestMedicos(form: any) {

    console.log(form);
    console.log(this.periodo);
    //return;

    if (!form.valid) {
      // marca campos como tocados
      this.poNotificationService.warning('Preencha corretamente todos os campos obrigatórios.');
      return;
    }

    this.medicosContabilService.requestMedicos(this.idEmpresa, this.periodo.start, this.periodo.end).subscribe((response) => {
      this.poDialogService.alert({
        title: 'Relatório - Médicos',
        message: 'Relatório gerado com sucesso. Dentro de instantes você receberá um e-mail com o relatório.',
      });

      form.reset();
      this.periodo = {};

    });
  }



}
